import { useCallback, useMemo, useState, type ReactNode } from 'react';

import {
    PublishRailCountContext,
    RailCountsContext,
    type PublishRailCount,
    type RailCounts,
} from './rail-counts';

/**
 * Houdt de tellers van de rail bij. Staat om de hele schil heen, zodat elk
 * scherm onder de `Outlet` zijn eigen getal kan publiceren met `useRailCount`.
 */
export function RailCountsProvider({ children }: { children: ReactNode }) {
    const [counts, setCounts] = useState<RailCounts>({});

    const publish = useCallback<PublishRailCount>((key, value) => {
        setCounts((current) => {
            if (current[key] === value) {
                return current;
            }

            const next = { ...current };

            if (value === undefined) {
                delete next[key];
            } else {
                next[key] = value;
            }

            return next;
        });
    }, []);

    const value = useMemo(() => counts, [counts]);

    return (
        <PublishRailCountContext.Provider value={publish}>
            <RailCountsContext.Provider value={value}>{children}</RailCountsContext.Provider>
        </PublishRailCountContext.Provider>
    );
}
